export function formatNotificationDateTime(
  backendDate: Date,
  today: Date
): string {
  const isToday: boolean = backendDate.toDateString() === today.toDateString();
  const yesterday: Date = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const isYesterday: boolean =
    backendDate.toDateString() === yesterday.toDateString();
  const isCurrentYear: boolean =
    backendDate.getFullYear() === today.getFullYear();

  if (isToday) {
    return `Today at ${backendDate.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    })}`;
  } else if (isYesterday) {
    return `Yesterday at ${backendDate.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    })}`;
  } else if (isCurrentYear) {
    return `${backendDate.toLocaleString('default', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
    })} at ${backendDate.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    })}`;
  } else {
    return `${backendDate.toLocaleString('default', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    })} at ${backendDate.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    })}`;
  }
}
